@if (events$ | async) {}
<div class="st-menu-collapse-item flex flex-column w-full">
  <a
    class="st-menu-collapse-item-header w-full flex align-items-center cursor-pointer py-6px px-12px"
    (click)="collapse()"
    [ngClass]="{ 'st-menu-collapse-item-active': isActive() }"
    [routerLink]="[menuItemData().routeUrl]"
  >
    <div class="flex gap-2 align-items-center flex-1">
      <em
        [ngClass]="menuItemData().iconClass"
        class="webkit-box-one-line label-large-light"
      ></em>
      <div class="webkit-box-one-line label-large-bold">
        {{ menuItemData().name }}
      </div>
    </div>
    @if (menuItemData().children.length) {
      <em
        class="ml-auto"
        [ngClass]="{
          'icon-caret-up': !isCollapsed(),
          'icon-caret-down': isCollapsed()
        }"
      ></em>
    }
  </a>
  @if (menuItemData().children.length) {
    <div
      class="st-menu-collapse-item-body w-full flex flex-column align-items-center"
      stCollapsible
      [isCollapsed]="isCollapsed()"
    >
      @for (item of menuItemData().children; track $index) {
        <a
          class="st-menu-collapse-item-body-element w-full flex align-items-center gap-2"
          [ngClass]="{
            'st-menu-collapse-item-body-element-active':
              activeChild?.id === item.id
          }"
          [routerLink]="[item.routeUrl]"
        >
          <div class="st-menu-collapse-item-body-element-left-side">
            <div class="top-line"></div>
            <div class="st-menu-collapse-item-body-element-left-side-dot"></div>
            <div class="bottom-line"></div>
          </div>
          <div
            class="st-menu-collapse-item-body-element-name label-large-regular webkit-box-one-line"
          >
            {{ item.name }}
          </div>
        </a>
      }
    </div>
  }
</div>
